import { type DiscoverySectionData } from 'services/store/discovery/types';
import { awsApi } from '../base';
import { environmentManager } from '../config';

const { isDevelopmentEnv } = environmentManager;
const folder = isDevelopmentEnv ? 'dev' : 'prd';

export const discoveryAwsApi = awsApi.injectEndpoints({
  endpoints: (build) => ({
    getPageData: build.query<Array<DiscoverySectionData>, void>({
      query: () => ({
        url: `/discovery_page/${folder}/data.json`,
      }),
    }),
  }),
  overrideExisting: false,
});
